export default "__VITE_ASSET__7K6bAwZv__"